import { Modal, Card } from "@mui/material";
import "../css/Override.scss";
import { useNavigate } from "react-router-dom";
import "./LoadGameModal.scss";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import GameService from "../../service/GameService";
import { SparkLineChart } from "@mui/x-charts/SparkLineChart";
import { ChartsReferenceLine } from "@mui/x-charts/ChartsReferenceLine";
import { lineElementClasses } from "@mui/x-charts/LineChart";
import AllDataClass from "../common/AllDataClass";

type ModalProp = {
  open: boolean;
  handleClose: () => void;
  handleGo: () => void;
};

const LoadGameModal = ({ open, handleClose, handleGo }: ModalProp) => {
  const { t } = useTranslation();
  const [gameid, setGameId] = useState("");
  const [showInput, setShowInput] = useState(true);
  const [username, setUserName] = useState("");
  const [selectedGoals, setSelectedGoals] = useState([]);
  const [selectedPolicyLists, setSelectedPolicyLists] = useState([]);
  const [debts, setDebts] = useState([]);
  const [pyi, setPYI] = useState(0.0);
  const [starScore, setStarScore] = useState([]);
  const [createAt, setCreateAt] = useState("");
  const navigate = useNavigate();

  const GoverningGoals = AllDataClass.getGoverningGoals();

  const start = async () => {
    try {
      var res = await GameService.getGame(gameid);
      console.log(res.data.game);
      var name = res.data.game.name;
      var goals = JSON.parse(res.data.game.goal);
      var policies = JSON.parse(res.data.game.policy);
      var debt = JSON.parse(res.data.game.debt);
      var pyi = res.data.game.pyi;
      var score = JSON.parse(res.data.game.score);
      var create = new Date(res.data.game.createdAt);

      console.log(name);
      console.log(goals);
      console.log(policies);
      console.log(debt);
      console.log(pyi);
      console.log(create.toLocaleDateString());
      setUserName(name);
      setSelectedGoals(goals);
      setSelectedPolicyLists(policies);
      setDebts(debt);
      setPYI(pyi);
      setStarScore(score);
      // setCreateAt(
      //   `${create.getFullYear()}년 ${create.getMonth() + 1}월 ${create.getDate()}일 ${create.getHours()}:${create.getMinutes()}`
      // );
      setCreateAt(create.toLocaleDateString());

      setShowInput(false);
    } catch (error) {
      console.log(error);
    }
    // handleGo();
  };
  const closeModal = () => {
    setShowInput(true);
    handleClose();
  };
  const goResult = () => {
    handleClose();
    navigate("/result", {
      state: {
        selectedGoals: selectedGoals,
        gameid: gameid,
        username: username,
        debt: debts,
        selectedPolicyLists: selectedPolicyLists,
        starScore: starScore,
        pyi: pyi,
      },
    });
  };
  const GoalLists = () => {
    var goal_list = new Array();
    var points = starScore;

    selectedGoals.map((selectedGoal: any, idx: number) => {
      var starPoint: any = points[idx];

      goal_list.push(
        <div className="gameresult-goal" key={idx}>
          <div className={`gameresult-goal-image ${selectedGoal.goalid}`}>
            {starPoint >= 3 && <div className="goal-star2" />}
            {starPoint >= 1 && <div className="goal-star1" />}
            {starPoint >= 4 && <div className="goal-star3" />}
          </div>
          <div className="gameresult-goal-name">{GoverningGoals[selectedGoal.goalid][0]}</div>
        </div>
      );
    });

    return goal_list;
  };
  return (
    <div>
      <Modal
        open={open}
        onClose={closeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="loadgame-modal-main"
      >
        {showInput === true ? (
          <div className="loadgame-modal-content">
            <button className="closebutton" onClick={closeModal} />
            <div className="modal-title">{t("loadbyid")}</div>
            <div className="modal-inputname">
              <input
                type="text"
                placeholder={t("input-id-here")}
                onChange={(e) => setGameId(e.target.value)}
                // onKeyDown={(e) => {
                //   e.key === "Enter" && start;
                // }}
              />
              <button onClick={start}>{t("confirm")}</button>
            </div>
            <div>{t("load21stElection")}</div>
          </div>
        ) : (
          <div className="loadgame-modal-gameresult">
            <div className="gameresult-wrap">
              <div className="gameresult-content">
                <div className="date">{createAt}</div>
                <div className="graph-wrap">
                  <SparkLineChart
                    className="graph"
                    data={debts}
                    sx={{
                      [`& .${lineElementClasses.root}`]: {
                        strokeWidth: 4,
                      },
                    }}
                    yAxis={{
                      min: 50,
                      max: 200,
                    }}
                    colors={["yellow"]}
                  >
                    <ChartsReferenceLine
                      y={150}
                      label=""
                      lineStyle={{ strokeDasharray: "10 5", strokeWidth: 4, stroke: "gray" }}
                    />
                  </SparkLineChart>
                </div>
                <div className="gameresult-goal-wrap">{GoalLists()}</div>
              </div>
              <div className="gameresult-button">
                <button className="cancel" onClick={closeModal}>
                  <span>{t("cancel")}</span>
                </button>
                <button className="confirm" onClick={goResult}>
                  <span>{t("confirm")}</span>
                </button>
              </div>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default LoadGameModal;
